const LocalStorageText = {
    Token: 'token'
}

const InitState = 'init'

const apiGetFile = "https://qafqtior.digiin.vn/"

export { LocalStorageText, InitState, apiGetFile }
